<template>
<!-- Created with Inkscape (http://www.inkscape.org/) -->

<svg
   version="1.1"
   id="svg1050"
   xml:space="preserve"
   width="682.66669"
   height="682.66669"
   viewBox="0 0 682.66669 682.66669"
   xmlns="http://www.w3.org/2000/svg"
   xmlns:svg="http://www.w3.org/2000/svg"><defs
     id="defs1054"><clipPath
       clipPathUnits="userSpaceOnUse"
       id="clipPath1068"><path
         d="M 0,512 H 512 V 0 H 0 Z"
         id="path1066" /></clipPath></defs><g
     id="g1056"
     transform="matrix(1.3333333,0,0,-1.3333333,0,682.66667)"><g
       id="g1058"
       transform="translate(127.5225,443.1865)"><path
         d="M 0,0 V -59.754"
         style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
         id="path1060" /></g><g
       id="g1062"><g
         id="g1064"
         clip-path="url(#clipPath1068)"><g
           id="g1070"
           transform="translate(161.3389,426.3203)"><path
             d="m 0,0 c 0,-9.298 -7.88,-16.866 -17.205,-16.866 -4.593,0 -16.498,-0.057 -16.498,-0.057 0,0 -0.085,12.246 -0.085,16.923 0,3.855 -0.028,16.866 -0.028,16.866 h 16.611 C -7.88,16.866 0,9.326 0,0 Z"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path1072" /></g><g
           id="g1074"
           transform="translate(196.6865,411.9487)"><path
             d="M 0,0 25.114,-28.517"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path1076" /></g><g
           id="g1078"
           transform="translate(189.4863,443.1865)"><path
             d="M 0,0 V -59.754"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path1080" /></g><g
           id="g1082"
           transform="translate(221.8008,427.6523)"><path
             d="m 0,0 c 0,-8.561 -7.512,-15.534 -16.412,-15.534 -4.394,0 -15.761,-0.056 -15.761,-0.056 0,0 -0.085,11.281 -0.085,15.59 0,3.572 -0.028,15.534 -0.028,15.534 h 15.874 C -7.512,15.534 0,8.589 0,0 Z"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path1084" /></g><g
           id="g1086"
           transform="translate(253.0381,443.1865)"><path
             d="M 0,0 V -59.754"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path1088" /></g><g
           id="g1090"
           transform="translate(330.082,438.084)"><path
             d="m 0,0 c -4.763,3.231 -10.517,5.103 -16.696,5.103 -16.497,0 -29.876,-13.38 -29.876,-29.878 0,-16.497 13.379,-29.877 29.876,-29.877 6.689,0 12.217,2.211 16.384,5.924 0.878,0.794 1.672,1.616 2.438,2.523"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path1092" /></g><g
           id="g1094"
           transform="translate(384.4775,442.6479)"><path
             d="M 0,0 H -24.944 V -59.216 H 0"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path1096" /></g><g
           id="g1098"
           transform="translate(382.6348,413.0542)"><path
             d="M 0,0 H -23.102"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path1100" /></g><g
           id="g1102"
           transform="translate(392.8389,341.7627)"><path
             d="M 0,0 H -273.678"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path1104" /></g><g
           id="g1106"
           transform="translate(301.9346,260.8613)"><path
             d="M 0,0 H -90.905"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path1108" /></g><g
           id="g1110"
           transform="translate(392.8389,297.7402)"><path
             d="M 0,0 H -181.81"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path1112" /></g><g
           id="g1114"
           transform="translate(301.9346,165.9004)"><path
             d="M 0,0 H -90.905"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path1116" /></g><g
           id="g1118"
           transform="translate(392.8389,202.751)"><path
             d="M 0,0 H -181.81"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path1120" /></g><g
           id="g1122"
           transform="translate(301.9346,70.9111)"><path
             d="M 0,0 H -90.905"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path1124" /></g><g
           id="g1126"
           transform="translate(392.8389,107.7617)"><path
             d="M 0,0 H -181.81"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path1128" /></g><g
           id="g1130"
           transform="translate(123.7529,303.041)"><path
             d="m 0,0 h 38.295 c 2.522,0 4.592,-2.069 4.592,-4.592 v -38.296 c 0,-2.523 -2.07,-4.592 -4.592,-4.592 H 0 c -2.522,0 -4.592,2.069 -4.592,4.592 V -4.592 C -4.592,-2.069 -2.522,0 0,0 Z"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path1132" /></g><g
           id="g1134"
           transform="translate(123.7529,208.0518)"><path
             d="m 0,0 h 38.295 c 2.522,0 4.592,-2.069 4.592,-4.592 v -38.296 c 0,-2.523 -2.07,-4.592 -4.592,-4.592 H 0 c -2.522,0 -4.592,2.069 -4.592,4.592 V -4.592 C -4.592,-2.069 -2.522,0 0,0 Z"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path1136" /></g><g
           id="g1138"
           transform="translate(123.7529,113.0908)"><path
             d="m 0,0 h 38.295 c 2.522,0 4.592,-2.098 4.592,-4.621 v -38.267 c 0,-2.551 -2.07,-4.621 -4.592,-4.621 H 0 c -2.522,0 -4.592,2.07 -4.592,4.621 V -4.621 C -4.592,-2.098 -2.522,0 0,0 Z"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path1140" /></g><g
           id="g1142"
           transform="translate(446.498,239.2896)"><path
             d="m 0,0 v -219.799 c 0,-6.605 -5.414,-11.991 -12.019,-11.991 h -356.987 c -6.604,0 -11.99,5.386 -11.99,11.991 V 0 m 0,34.611 V 253.22 c 0,6.605 5.386,11.99 11.99,11.99 H -12.019 C -5.414,265.21 0,259.825 0,253.22 V 34.611"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path1144" /></g></g></g></g></svg>
</template>
